import { TLabelType } from '../../../../types/specialPromos/specialPromos';

export const LABEL_BACKGROUNDS: Record<TLabelType, string> = {
  mortgage: 'primary_10',
  sale: 'primary_10',
  newbuildingCount: 'black_6',
  discount: 'success_10',
  bonus: '#ff7e001a',
};

export const LABEL_COLORS: Record<TLabelType, string> = {
  mortgage: 'primary_100',
  sale: 'primary_100',
  newbuildingCount: 'black_100',
  discount: 'success_100',
  bonus: '#db6f0a',
};
